import { create } from "../../../common/utils/zustand_state_manager";
import { ObrasService } from "../../../features/obras/data/services/obras_service_impl";
import { IObrasService } from "../../../features/obras/data/services/obras_service";


/**
 * useObrasServices
 */

type State = {
  obrasService: IObrasService,
};

export const useObrasServices = create<State>((set, get) => ({
  obrasService: new ObrasService(),
}));